import { ContactUs, CopyrightFooter } from 'app/components'
import { Container, IAppState } from 'app/containers/Container'
import * as React from 'react'
import { Button, Carousel, Col, Row } from 'react-bootstrap'

class Background extends Container<{}, {}> {
  mapAppStateToContainerState(appState: IAppState): {} {
    return {}
  }

  render() {
    return (
      <section className="padding-top-lg">
        <div className="container" style={{ overflowX: 'hidden' }}>
          <div className="jumbotron animated fadeIn">
            <p className="lead" style={{ fontWeight: 'bold' }}>How are Foundations Investments Performing?</p>
            <p className="lead">This seemed a like a pretty straightforward question, and an important one for foundation trustees to ask, however, when we looked for reliable performance data on the subject, we simply couldn’t find it.  We thought others might have the same problem, so we created FoundationMark to provide an answer to the essential question above, as well as to provide other benchmarking metrics.</p>
            <p className="lead">
              FoundationMark tracks the investment performance of over 40,000 foundations, which collectively represent over 97% of all foundation assets.  We use this data to construct bottom-up indices and representative peer groups.
            </p>
            <p className="lead">FoundationMark believes that independent, representative and objective benchmarks are fundamental to evaluating investment performance.</p>
            <p className="lead" style={{ fontWeight: 'bold' }}>How is <span style={{ textDecoration: 'underline' }}>Our</span> Foundation Doing?</p>
            <p className="lead">Knowing how the overall foundation market is doing is important, but knowing your foundation’s performance is vital.</p>
            <p className="lead">
              <ul>
                <li>
                  How does our performance compare to other foundations? To the stock and bond markets?
                </li>
                <li>Are there other foundations like us? How does our performance compare? Are our investment expenses in-line with our peers?</li>
              </ul>
            </p>
            <p className="lead">FoundationMark provides trustees with free reports on their foundations performance including comparisons to public market indices and our easy-to-read star rating system.</p>
            <p className="lead">Better investment performance means more money to charity and better investment data can be a key resource in evaluating your foundation’s performance. </p>
            <p className="lead">
              If you are a trustee and you want your free FoundationMark Performance Report. <a href="#/are-you-foundation">Click here</a>.
            </p>
          </div>
        </div>

        <ContactUs />
        <CopyrightFooter />
      </section>
    )
  }
}

export {
  Background
}



// WEBPACK FOOTER //
// ./src/app/containers/Background/index.tsx